import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 5,
  filterType: {
    status: "",
    relatedBranch: "",
    relatedSupplier: "",
    paymentType: "",
    startDate: "",
    endDate: "",
  },
  keyword: "",
};
const purchaseVoucherSlice = createSlice({
  initialState,
  name: "filterPurchaseVoucher",
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearch: (state, action) => {
      state.keyword = action.payload;
    },
    setFilter: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    resetAll: (state) => {
      state.page = 1;
      state.limit = 5;
      state.keyword = "";
      state.filterType = {
        status: "",
        relatedBranch: "",
        relatedSupplier: "",
        paymentType: "",
        startDate: "",
        endDate: "",
      };
    },
  },
});

export const { setPage, setLimit, setSearch, setFilter, resetAll } =
  purchaseVoucherSlice.actions;

export default purchaseVoucherSlice.reducer;
